module.exports = __webpack_public_path__ + "img/img-2.95135683.png";